export default __webpack_public_path__ + "static/media/Our_Story.e207916e.png";